import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success(`Benvenuto, ${res.user.full_name}`);
      nav(res.user.role === "admin" ? "/admin" : "/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-4 md:px-0 py-16 scale-in">
        <div className="card-surface rounded-3xl p-8 shadow-xl">
          <h1 className="display font-black text-3xl mb-2">Accedi</h1>
          <p className="text-slate-500 text-sm mb-6">Entra nella tua area riservata.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-slate-600">Email</Label>
              <Input id="email" type="email" autoComplete="email" required value={email}
                     onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                     className="bg-slate-50 border-slate-200 mt-1" />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-600">Password</Label>
              <Input id="password" type="password" autoComplete="current-password" required value={password}
                     onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                     className="bg-slate-50 border-slate-200 mt-1" />
            </div>
            <Button type="submit" disabled={busy} className="btn-brand w-full rounded-full h-11" data-testid="login-submit">
              {busy ? "Accesso..." : "Entra"}
            </Button>
          </form>
          <p className="text-slate-500 text-sm mt-6 text-center">
            Non hai un account?{" "}
            <Link to="/register" className="underline" style={{ color: "var(--brand)" }}>Registrati</Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
